import React, { useEffect } from 'react';

/**
 * Component for hiding zendesk widget.
 *
 * @param {React.PropsWithChildren} props
 */
export const ZendeskHider = ({ children }) => {
    useEffect(() => {
        if (!window.zE) return;

        window.zE('webWidget', 'hide');

        return () => window.zE('webWidget', 'show');
    }, []);

    return <>{children}</>;
};
